const OperationExtensionsMap: {
	[operationName: string]: unknown[] | undefined;
} = {};

export const startCapturingExtensions = (operationName: string): void => {
	OperationExtensionsMap[operationName] = OperationExtensionsMap[operationName] || [];
};
export const stopCapturingExtensions = (operationName: string): void => {
	OperationExtensionsMap[operationName] = undefined;
};
export const putExtensions = (operationName: string, extension: unknown): void => {
	if (extension !== undefined) {
		const extensionsForOperation = OperationExtensionsMap[operationName];
		if (extensionsForOperation !== undefined) {
			extensionsForOperation.push(extension);
		}
	}
};

export const getExtensions = (operationName: string): unknown[] => OperationExtensionsMap[operationName] || [];
